import { createContext, useCallback, useState } from 'react'

import { useSelectRowTable } from 'hooks/use-select-row-table'

import {
  ChargeContextProviderProps,
  ChargeContextProviderState,
  ControlledModalCharge
} from './context.interface'

export const ChargeContext = createContext({} as ChargeContextProviderState)

export function ChargeContextProvider({
  children
}: ChargeContextProviderProps) {
  const [reloadNfse, setReloadNfse] = useState(false)
  const [reloadTable, setReloadTable] = useState(false)
  const [modal, setModal] = useState<ControlledModalCharge>({
    registerReceipt: false,
    charge: false,
    chargeDetail: false,
    chargeUuid: '',
    detailInvoice: false,
    invoice: false,
    invoiceSettings: false,
    invoiceSettingsDrawer: false,
    nfseRecurrencesDrawer: false,
    nfseRecurrencesDrawerAutoOpenForm: false,
    nfseRecurrenceFormModal: false,
    contractModelsDrawer: false,
    isOpenDetails: false,
    isOpenInvoiceDetails: false,
    loading: false,
    modalNewCharge: false,
    modalNewRecurrence: false,
    modalRecurrenceDetail: false,
    modalUploadComponent: false,
    product: false,
    recurrence: false,
    recurrenceDetail: false,
    modalNegativation: false,
    recurrenceUuid: '',
    customer: {
      label: '',
      uuid: ''
    },
    uuid: '',
    uuidCustomer: '',
    uuidInvoice: '',
    uuidRecurrenceDetail: '',
    modalUploadNfseXml: false,
    nextAdjustmentsDrawer: false
  } as ControlledModalCharge)

  const updateTable = () => {
    setReloadTable((prevState) => !prevState)
  }

  const updateNfse = () => {
    setReloadNfse((prevState) => !prevState)
  }

  const toggleModal = useCallback(
    (key: keyof typeof modal, uuid = '') =>
      setModal((prevState) => ({ ...prevState, [key]: !prevState[key], uuid })),
    []
  )

  const { select, setSelect, resetSelectedFields } = useSelectRowTable({
    useSelected: false
  })

  return (
    <ChargeContext.Provider
      value={{
        reloadTable,
        updateTable,
        reloadNfse,
        updateNfse,
        modal,
        updateModal: setModal,
        toggleModal,
        select,
        setSelect,
        resetSelectedFields
      }}
    >
      {children}
    </ChargeContext.Provider>
  )
}
